export default __webpack_public_path__ + "static/media/logo.ff8afd8a.svg";